'use strict';

module.exports = {
	CognitoApi: require('../../models/cognito-api'),
	CognitoIdentityShim: require('../../models/cognito-identity-shim'),
	CognitoAuthenticator: require('../../models/cognito-authenticator'),
	CognitoModel: require('../../models/cognito-model')
};
